
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { QueryClientProvider } from '@tanstack/react-query'
import { queryClient } from './lib/queryClient'
import { LoadingProvider } from './components/mobile/ProgressiveLoader'
import { HelmetProvider } from 'react-helmet-async'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <HelmetProvider>
        <LoadingProvider>
          <App />
        </LoadingProvider>
      </HelmetProvider>
    </QueryClientProvider>
  </React.StrictMode>,
)
